import createReactComponent from '../createReactComponent';
export default createReactComponent('arrow-long-down', 'ArrowLongDown', [["path",{"d":"m16 18-4 4-4-4m4 4V2","key":"svg-0"}]]);